<template>
  <div>
    <!-- Loading -->
    <div v-if="loading">
      Cargando...
    </div>
    <!-- Not loading -->
    <div v-else>
      <!-- Empty -->
      <div v-if="isEmpty">
        <p class="sin-datos">
          Este comercio no cuenta con beneficios actualmente
        </p>
      </div>
      <!-- Not empty -->
      <div v-else>
        <div class="table-responsive">
          <table id="tablaBeneficios" class="table">
            <thead>
              <tr>
                <th>Descuento</th>
                <th>Días</th>
                <th>Medios de Pago</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ben in list" v-bind:key="ben.id">
                <th scope="row" >
                  {{ ben.porcentajeDescuento }}
                </th>
                <td>{{ ben.diasHabilitados | diasSemana }}</td>
                <td>{{ ben.medioPago }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <Paginacion
          ref="paginacionBeneficios"
          :cantidad="count"
          :cantidadPorPagina="maxPerPage"
          :paginaInicial="currentPage"
          v-on:pagina-cambiada="onPageChanged"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Paginacion from "../../../components/Paginacion.vue";

const ON_PAGE_CHANGED_EVENT = "on-page-changed";

export default {
  props: {
    loading: Boolean,
    isEmpty: Boolean,
    list: Array,
    count: Number,
    maxPerPage: Number,
    currentPage: Number
  },
  components: {
    Paginacion
  },
  methods: {
    onPageChanged(pageNumber) {
      this.$emit(ON_PAGE_CHANGED_EVENT, pageNumber);
    }
  }
};
</script>
